<template>
  <div class="row no-gutters">
    <div class="col">
      <div class="lkc-logo">
        <div class="title">
          Twitter
        </div>
        <div class="subtitle">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  methods: {
    changeLanguage(language) {
      this.$i18n.locale = language
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .buttons {
    padding: 20px;
  }
  .buttons a {
    cursor: pointer;
    margin: 0 5px;
  }
  .row {
    height: 156px;
  }

  .lkc-logo {
    float:left;
    padding: 50px 0px 0px 50px;
  }

  .title {
    font-family: Times New Roman;
    font-size: 28px;
    line-height: 32px;


    color: #000000;
  }

  .subtitle {
    font-family: Times New Roman;
    font-size: 18.7px;;
    line-height: 23px;
    /* identical to box height */



    color: #000000;
  }

  @media (max-width: 575.98px) {
    .lkc-logo {
      padding: 20px 0px 0px 20px;

    }

    .title {
      font-size: 17px;
      line-height: 19px;
  
    }

    .subtitle {
      font-size: 11.4px;
      line-height: 15px;
    }
  }

</style>
